import React from 'react';
import { Shield, TrendingUp, Users } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

export default function AboutSection() {
  const features = [
    {
      icon: Shield,
      title: 'Security',
      description: 'All transactions are fully secured & compliant with applicable law for corporate clients.'
    },
    {
      icon: TrendingUp,
      title: 'Competitive Rates',
      description: 'We offer competitive exchange rates tailored to wholesale business needs and corporate requirements.'
    },
    {
      icon: Users,
      title: 'Comprehensive Services',
      description: 'From small business needs to large corporate transactions - we serve all business client types.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Why Do Clients Choose Us?
          </h2>
          <div className="w-24 h-1 bg-green-600 mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
            We are a trusted partner for businesses worldwide, offering professional currency exchange 
            services tailored to corporate needs. Whether you're a small enterprise or a large corporation, 
            our commitment to excellence makes us the preferred choice for business clients.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card key={index} className="group hover:shadow-xl transition-all duration-300 border-0 bg-white">
              <CardContent className="pt-12 pb-8 px-8 text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-blue-900 to-blue-700 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <feature.icon className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-xl font-bold text-blue-900 mb-4">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl p-8 md:p-12 text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Ready to Get Started?
          </h3>
          <p className="text-blue-100 text-lg mb-6">
            Join hundreds of businesses worldwide who trust us with their corporate currency exchange needs.
          </p>
          <div className="flex justify-center space-x-4">
            <div className="text-center">
              <div className="text-3xl font-bold text-green-400">500+</div>
              <div className="text-blue-200 text-sm">Happy Clients</div>
            </div>
            <div className="w-px h-12 bg-blue-700"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-green-400">€50M+</div>
              <div className="text-blue-200 text-sm">Exchanged</div>
            </div>
            <div className="w-px h-12 bg-blue-700"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-green-400">5+</div>
              <div className="text-blue-200 text-sm">Years Experience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}